<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre" id="pgepubid00002">
      PROLOGUE
    </h2>
<p class="calibre3">
      One early April afternoon, in a Worcestershire field, the only field in
      that immediate landscape which was not down in grass, a man moved slowly
      athwart the furrows, sowing—a big man of heavy build, swinging his
      hairy brown arm with the grace of strength. He wore no coat or hat; a
      waistcoat, open over a blue-checked cotton shirt, flapped against belted
      corduroys that were somewhat the color of his square, pale-brown face and
      dusty hair. His eyes were sad, with the swimming yet fixed stare of
      epileptics; his mouth heavy-lipped, so that, but for the yearning eyes,
      the face would have been almost brutal. He looked as if he suffered from
      silence. The elm-trees bordering the field, though only just in leaf,
      showed dark against a white sky. A light wind blew, carrying already a
      scent from the earth and growth pushing up, for the year was early. The
      green Malvern hills rose in the west; and not far away, shrouded by trees,
      a long country house of weathered brick faced to the south. Save for the
      man sowing, and some rooks crossing from elm to elm, no life was visible
      in all the green land. And it was quiet—with a strange, a brooding
      tranquillity. The fields and hills seemed to mock the scars of road and
      ditch and furrow scraped on them, to mock at barriers of hedge and wall—between
      the green land and white sky was a conspiracy to disregard those small
      activities. So lonely was it, so plunged in a ground-bass of silence; so
      much too big and permanent for any figure of man.
    </p>
<p class="calibre3">
      Across and across the brown loam the laborer doggedly finished out his
      task; scattered the few last seeds into a corner, and stood still.
      Thrushes and blackbirds were just beginning that even-song whose
      blitheness, as nothing else on earth, seems to promise youth forever to
      the land. He picked up his coat, slung it on, and, heaving a straw bag
      over his shoulder, walked out on to the grass-bordered road between the
      elms.
    </p>
<p class="calibre3">
      “Tryst! Bob Tryst!”
     </p>
<p class="calibre3">
      At the gate of a creepered cottage amongst fruit-trees, high above the
      road, a youth with black hair and pale-brown face stood beside a girl with
      frizzy brown hair and cheeks like poppies.
    </p>
<p class="calibre3">
      “Have you had that notice?”
     </p>
<p class="calibre3">
      The laborer answered slowly:
    </p>
<p class="calibre3">
      “Yes, Mr. Derek. If she don't go, I've got to.”
     </p>
<p class="calibre3">
      “What a d—d shame!”
     </p>
<p class="calibre3">
      The laborer moved his head, as though he would have spoken, but no words
      came.
    </p>
<p class="calibre3">
      “Don't do anything, Bob. We'll see about that.”
     </p>
<p class="calibre3">
      “Evenin', Mr. Derek. Evenin', Miss Sheila,” and the laborer moved on.
    </p>
<p class="calibre3">
      The two at the wicket gate also turned away. A black-haired woman dressed
      in blue came to the wicket gate in their place. There seemed no purpose in
      her standing there; it was perhaps an evening custom, some ceremony such
      as Moslems observe at the muezzin-call. And any one who saw her would have
      wondered what on earth she might be seeing, gazing out with her dark
      glowing eyes above the white, grass-bordered roads stretching empty this
      way and that between the elm-trees and green fields; while the blackbirds
      and thrushes shouted out their hearts, calling all to witness how hopeful
      and young was life in this English countryside....
    </p>
<p class="calibre3">
<a id="link2HCH0001">
</a>
</p>
<div class="pg-boilerplate" id="calibre_pb_5"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?331e5842